import "bootstrap/dist/css/bootstrap.min.css";
import leuwint_logo from "./images/leuwint_logo.jpg";
import "../NavBar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setForEdit, setUserID } from "../app/state/userSlice";

function NavBar({ postJobFlag, logOutFlag, username }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function logout() {
    dispatch(setUserID(null));
    navigate("/");
  }

  const postJobBtn = (
    <button
      className='btn btn-primary'
      onClick={() => {
        navigate("/postjob");
        dispatch(setForEdit(false));
      }}
      type='button'
    >
      Create a Job
    </button>
  );

  const logOutBtn = (
    <button className='btn btn-outline-primary mx-3' type='button' onClick={logout}>
      Log Out
    </button>
  );

  return (
    <>
      <nav className='navbar navbar-expand-lg bg-body-tertiary'>
        <div className='container-fluid'>
          <a className='navbar-brand' href='#'>
            <img onClick={()=>{navigate("/home")}} src={leuwint_logo} alt='Bootstrap' width='60' height='48' />
          </a>
          <button
            className='navbar-toggler'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarSupportedContent'
            aria-controls='navbarSupportedContent'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon'></span>
          </button>
          <div className='collapse navbar-collapse' id='navbarSupportedContent'>
            <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
              <li className='nav-item'>
                <a className='nav-link active' aria-current='page' href='#'>
                  Jobs
                </a>
              </li>
              <li className='nav-item'>
                <a className='nav-link active' aria-current='page' href='#'>
                  Ask Leu
                </a>
              </li>
            </ul>
            <div className='d-grid gap-2 d-md-block'>
              {logOutFlag && logOutBtn}
              {postJobFlag && postJobBtn}
            </div>
            <div>
              {" "}
              <button className='btn btn-outline' type='button'>
                <div>
                  <FontAwesomeIcon icon={faUser} />{" "}
                </div>
                {username}
              </button>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default NavBar;
